const quotationChat = {
  quotationChatNavLabel: "見積りチャット", // translated 
  quotationChatApprovalTitle: "見積りチャット", // translated 
  quotationChatAccountNotApprovedTitle: "アカウント未承認", // translated 
  quotationChatAccountNotApprovedDescription:
    "アカウントはまだ承認されていません。詳細についてはアカウントマネージャーにお問い合わせください。", // translated 
  quotationChatViewAiChat: "A.I.チャットを表示", // translated 

  quotationRequestChatSessions: "チャットセッション", // translated 
  quotationRequestChatNoPastSessions: "過去のセッションはありません", // translated 
  quotationRequestChatNewChat: "新しいチャット", // translated 
  quotationRequestChatCloseSidebar: "サイドバーを閉じる", // translated 
  quotationRequestChatSessionFallback: "チャットセッション", // translated 
  quotationRequestChatDefaultSessionName: "新しいチャットセッション", // translated 
  quotationRequestChatTitle: "見積り依頼チャット", // translated 
  quotationRequestChatResponseLanguageLabel: "応答言語", // translated 
  quotationRequestChatOpenSidebar: "サイドバーを開く", // translated 
  quotationRequestChatRenameSession: "セッション名を変更しました", // translated 
  quotationRequestChatDeleteSession: "セッションを削除", // translated 
  quotationRequestChatToggleDarkMode: "ダークモードを切り替える", // translated 
  quotationRequestChatSwitchToLightMode: "ライトモードに切り替える", // translated 
  quotationRequestChatSwitchToDarkMode: "ダークモードに移行", // translated 
  quotationRequestChatEmptyStateHeading: "新しい見積り依頼の会話を開始", // translated 
  quotationRequestChatEmptyStateSubheading:
    "ご旅行のご要望をお聞かせください。見積り依頼を作成いたします。", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "メッセージを入力して会話を開始...（Shift+Enterで変更）", // translated 
  quotationRequestChatMessagePlaceholder: "メッセージを入力...（Shift+Enterで変更）", // translated 
  quotationRequestChatUploadFile: "ファイルをアップロード", // translated 
  quotationRequestChatUploadAttachment: "添付ファイルをアップロード", // translated 

  quotationRequestChatStopGenerating: "生成を停止", // translated 
  quotationRequestChatGenerateQuotation: "見積りを生成", // translated 
  quotationRequestChatGenerateFinalQuotation: "最終見積りを生成", // translated 
  quotationRequestChatFinalizeQuotationRequest: "見積り依頼を確定", // translated 
  quotationRequestChatHoldToRecord: "長押しで音声メッセージを録音", // translated 
  quotationRequestChatRecordingReleaseToSend: "録音中、離すと送信", // translated 
  quotationRequestChatRecording: "録音中...", // translated 
  quotationRequestChatSelectSessionFirst: "先にチャットセッションを選択してください。", // translated 
  quotationRequestChatCancelVoiceRecording: "音声録音をキャンセルする", // translated 
  quotationRequestChatListening: "聞いています...", // translated 
  quotationRequestChatTranscribing: "事件起こし中...", // translated 

  quotationRequestChatFileUploadedSuccess: "ファイルが通常にアップロードされました。", // translated 
  quotationRequestChatUnsupportedFileType: "未対応のファイル形式です。PDF、Word（.docx）、Excel（.xlsx）、PowerPoint（.pptx）、テキスト/CSV、または画像をアップロードしてください。", // translated
  quotationRequestChatFailedCreateSession: "チャットセッションの作成に失敗しました。もう一度試してください。", // translated 
  quotationRequestChatFailedUploadFile: "ファイルのアップロードに失敗しました。もう一度試してください。", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "別のメッセージを送信する前に、保留中の質問にお答えください。", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "見積り依頼を確定する前に、保留中の質問にお答えください。", // translated 
  quotationRequestChatFavoriteMarked: "チャットセッションをお気に入りに追加しました", // translated 
  quotationRequestChatFavoriteUnmarked: "チャットセッションをお気に入りから削除しました", // translated 
  quotationRequestChatFailedSetFavorite: "お気に入りの設定に失敗しました", // translated 
  quotationRequestChatFailedUnsetFavorite: "お気に入りの解除に失敗しました", // translated 
  quotationRequestChatRenamedSuccess: "チャットセッション名が通常に変更されました。", // translated 
  quotationRequestChatFailedRename: "チャットセッション名の変更に失敗しました。もう一度試してください。", // translated 
  quotationRequestChatDeletedSuccess: "チャットセッションが正常に削除されました。", // translated 
  quotationRequestChatFailedDelete: "チャットセッションの削除に失敗しました。もう一度試してください。", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "添付ファイルが通常に削除されました。", // translated 
  quotationRequestChatFailedDeleteAttachment: "添付ファイルの削除に失敗しました。もう一度お試しください。", // translated 
  quotationRequestChatSubmittedSuccess:
    "見積り依頼が通常に送信されました！リクエストを処理中です。", // translated 
  quotationRequestChatFailedSubmit: "見積り依頼の送信に失敗しました", // translated 
  quotationChatPdfDownloadedSuccess: "PDFが通常にダウンロードされました！", // translated 
  quotationChatFailedGeneratePdf: "PDFの生成に失敗しました", // translated 

  quotationRequestChatSubagentRequired:
    "見積り依頼を送信する前に、サブエージェントユーザーを選択してください。", // translated 
  quotationRequestChatAppUserLoading:
    "CRMアプリのユーザープロフィールを読み込み中です。しばらくしてからもう一度お試しください。", // translated 
  quotationRequestChatAppUserMismatch:
    "CRM アプリ ユーザーのプロフィールはこのチャット セッションとは一致しません。", // translated 

  quotationRequestChatRenameTitle: "チャットセッション名を変更", // translated 
  quotationRequestChatSessionName: "セッション名", // translated 
  quotationRequestChatEnterSessionName: "セッション名を入力", // translated 
  quotationRequestChatSaving: "保存中...", // translated 
  quotationRequestChatSave: "保存", // translated 
  quotationRequestChatDeleteTitle: "チャットセッションを削除", // translated 
  quotationRequestChatDeleteConfirm: "このチャットセッションを削除してもよろしいですか?", // translated 
  quotationRequestChatDeleteCannotUndo: "この操作は元に戻りません。", // translated 
  quotationRequestChatDeleting: "削除中...", // translated 
  quotationRequestChatDelete: "削除", // translated 

  quotationRequestChatAttachmentsTitle: "見積り依頼チャットの添付ファイル", // translated 
  quotationRequestChatLoadingAttachments: "添付ファイルの読み込み中...", // translated 
  quotationRequestChatNoAttachments: "添付ファイルが見つかりません", // translated 
  quotationRequestChatDeleteAttachment: "添付ファイルを削除", // translated 
  quotationRequestChatUploadingAttachment: "添付ファイルをアップロード中...", // translated 
  quotationRequestChatUploadingAttachmentWait: "ファイルのアップロードが完了するまでしてください。", // translated 

  quotationRequestChatAnswerPendingQuestions: "保留中の質問に回答", // translated 
  quotationRequestChatProposeOwnAnswer: "自分自身の答えの提案", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "の回答を入力...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{回答済み}} / {{total}}件回答済み", // translated 
  quotationRequestChatReadyToSubmit: "送信準備完了", // translated 
  quotationRequestChatSubmitAll: "すべて送信", // translated 
  quotationRequestChatRespondToOneQuestion: "{{count}}件の質問への回答", // translated 
  quotationRequestChatRespondToManyQuestions: "{{count}}件の質問への回答", // translated 

  quotationRequestChatFinalizeTitle: "見積り依頼を確定", // translated 
  quotationRequestChatLoadingSessionData: "セッションデータを読み込み中...", // translated 
  quotationRequestChatErrorLoadingSession: "セッションデータの読み込みエラー。もう一度お試しください。", // translated 
  quotationRequestChatQuotationTitle: "見積りタイトル", // translated 
  quotationRequestChatExtraComments: "コメント追加", // translated 
  quotationRequestChatSubmitting: "送信中...", // translated 
  quotationRequestChatSubmit: "送信", // translated 
  quotationRequestChatSubmittingOverlayTitle: "見積り依頼を送信中...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "見積り依頼の送信が完了するまでお願いいたします。", // translated 

  quotationRequestChatSelectSubagent: "サブエージェントを選択", // translated 
  quotationRequestChatSearchSubagents: "サブエージェントを検索...", // translated 
  quotationRequestChatLoadingSubagents: "サブエージェントを読み込み中...", // translated 
  quotationRequestChatNoSubagentsFound: "サブエージェントが見つかりません", // translated 
  quotationRequestChatNoSubagentsAvailable: "利用可能なサブエージェントがありません", // translated 
  quotationRequestChatSelectedSubagent: "選択済み: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "サブエージェントユーザー", // translated 
  quotationRequestChatSearchUsers: "ユーザーを検索...", // translated 
  quotationRequestChatNoUsersFound: "ユーザーが見つかりません", // translated 
  quotationRequestChatNoUsersAvailable: "利用可能なユーザーがいない", // translated 

  quotationChatDownloadSummaryTitle: "見積りサマリーをダウンロード", // translated 
  quotationChatDownloadSummaryDescription:
    "以下に詳細を入力して、旅行のパーソナライズされたPDFサマリーを生成してください。PDFには、旅行の詳細、目的地、交通情報、日別の旅程が含まれます。", // translated 
  quotationChatCustomerTitle: "敬称", // translated 
  quotationChatSelectTitle: "敬称を選択", // translated 
  quotationChatHonorificMr: "氏", // translated 
  quotationChatHonorificMrs: "夫人", // translated 
  quotationChatHonorificMs: "MS。", // translated 
  quotationChatHonorificDr: "博士", // translated 
  quotationChatHonorificProf: "教授", // translated 
  quotationChatCustomerPhone: "電話", // translated 
  quotationChatCustomerCompany: "会社", // translated 
  quotationChatCustomerMessage: "メッセージ", // translated 
  quotationChatCustomerCountry: "国", // translated 
  quotationChatGenerating: "生成中...", // translated 
  quotationChatDownloadPdf: "PDFをダウンロード", // translated 

  quotationChatTripSummary: "旅行サマリー", // translated 
  quotationChatDownloadAsPdf: "PDFとしてダウンロード", // translated 
  quotationChatNoTripSummary: "このセッションには旅行サマリーはありません。", // translated 

  quotationRequestChatThinking: "考え中...", // translated 
  quotationRequestChatSources: "ソース", // translated 
  quotationRequestChatSearchingWebFor: 'ウェブ検索中: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "ツアーオペレーターが実行するサービス", // translated 
  quotationRequestChatServicesByCustomer: "お客様が対応するサービス", // translated 
  quotationRequestChatReadyNotice:
    "右側のボタンをクリックして、この依頼の見積もりを生成できます。", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "最終見積りを生成", // translated 

  quotationRequestChatMaybeYouWantToAsk: "こちらも質問してください:", // translated 
  quotationRequestChatClickToSendSuggestion: "クリックしてこのメッセージを送信", // translated 

  quotationRequestChatAddToFavorites: "お気に入りに追加", // translated 
  quotationRequestChatRemoveFromFavorites: "お気に入りから削除", // translated 
  quotationRequestChatSubmitted: "送信済み", // translated 

  quotationRequestChatQuotationRequest: "見積もり依頼: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{タイトル}}", // translated 
  quotationRequestChatQuotationTooltipStatus: " - ステータス: {{ステータス}}", // translated 

  quotationChatLoading: "読み込み中...", // translated 
  quotationChatSessionNotFound: "この見積りのチャットセッションが見つかりません", // translated 
  quotationChatMemberSessionNotFound: "アカウントのメンバーセッションが見つかりません", // translated 
  quotationChatUnableToConnect: "チャットに接続できません", // translated 
  quotationChatConnecting: "接続中...", // translated 
  quotationChatTypeYourMessage: "メッセージを入力...", // translated 
  quotationChatConnected: "接続済み", // translated 
  quotationChatConnectingStatus: "接続中...", // translated 
  quotationChatDisconnected: "切断", // translated 
};


export default quotationChat;
